// Portuguese (Brazilian) translations — a complete map of every English key in
// resources.js, kept in the same order. Add a key here whenever one is added to en.
export const pt = {
  add_remove_asset_pairs: "Adicionar/remover pares de negociação",
  trading: "Pares de negociação",
  tradingTitle: "Negociação",
  edit: "Editar",
  title: "Título",
  try_to_refresh: "Tente atualizar esta página.",
  refresh: "Atualizar",
  no_asset_configured: "Nenhum ativo configurado",
  contact_to_add_asset: "Fale com o suporte para adicionar um novo ativo",
  coin_address: "Endereço da moeda",
  error_price_feed: "Erro ao conectar ao feed de preços",
  hide_filters: "Ocultar filtros",
  display_filters: "Exibir filtros",
  hide_withdraw: "Ocultar painel de saque",
  show_withdraw: "Mostrar painel de saque",
  update_successful: "Atualizado com sucesso",
  sucessfully_added_pair: "Você adicionou o novo par com sucesso",
  error_occured: "Ocorreu um erro",
  successfully_updated_pair: "Você atualizou o formulário de exibição do par com sucesso",
  filter_trades: "Filtrar operações",
  filter: "Filtrar",
  buy: "Comprar",
  sell: "Vender",
  buy_l: "comprar",
  sell_l: "vender",
  accept: "Aceitar",
  decline: "Recusar",
  size_min: "Tamanho mín.",
  size_max: "Tamanho máx.",
  trade_id: "ID da operação",
  type: "Tipo",
  date_from: "Data inicial",
  date_to: "Data final",
  trades_history: "Histórico de operações",
  size: "Tamanho",
  search: "Buscar",
  trade_value: "Valor da operação",
  price: "Preço",
  time: "Hora",
  add_new_pair: "Adicionar novo par de negociação",
  edit_trade_form: "Editar pares de negociação",
  update_form: "Atualizar formulário",
  pair_shown: "Pares exibidos",
  close: "Fechar",
  confirmation: "Confirmação",
  add_pair: "Adicionar par",
  update_trade_settings: "Atualizar pares de negociação",
  bad_request: "Requisição inválida",
  request_result_error: "Sua requisição resultou em erro",
  back_to_homepage: "Voltar à página inicial",
  forbidden: "Acesso negado",
  no_permission: "Você não tem permissão para ver este recurso",
  was_not_found: "A página que você procurava não foi encontrada",
  address_mistyped: "Você pode ter digitado o endereço errado ou a página pode ter sido movida",
  internal_server_error: "Erro interno do servidor",
  service_unavailable: "Serviço indisponível",
  want_to_add_key: "Deseja adicionar uma nova chave de API para o cliente",
  adding_new_key: "Adicionando nova chave de API",
  new_api_key: "Nova chave de API",
  generate_callback_secret: "Gerar segredo de callback",
  cancel: "Cancelar",
  create_api_key: "Criar chave de API",
  write_down_secret: "Anote o segredo da nova chave de API",
  write_down_callbacl_secret: "Anote o novo segredo de callback",
  key: "Chave",
  secret: "Segredo",
  closing_api_key_window: "Depois de fechar esta janela, você não poderá recuperar o segredo da chave de API",
  closing_callback_secret_window: "Depois de fechar esta janela, você não poderá recuperar o segredo de callback",
  api_key_created: "Chave de API criada",
  generated_callback_secret: "Segredo de callback gerado",
  saved_secret: "Salvei o segredo da chave de API",
  saved_callback_secret: "Salvei o segredo de callback",
  api_keys: "Chaves de API",
  api_key_deleted: "Chave de API excluída",
  api_key_delete_success: "A chave de API foi excluída com sucesso",
  about_to_delete_key: "Você está prestes a excluir a chave de API",
  client: "Cliente",
  clients_summary: "Resumo dos clientes",
  assets_summary: "Resumo dos ativos",
  supported_assets: "Ativos compatíveis",
  want_to_continue: "Deseja continuar?",
  deleting_api_key: "Excluindo chave de API",
  delete_api_key: "Excluir chave de API",
  active_api_keys: "Chaves de API ativas",
  delete: "Excluir",
  assets: "Ativos",
  trading_config: "Config. de negociação",
  primary: "Principal",
  secondary: "Secundário",
  min_trade: "Operação mín.",
  max_trade: "Operação máx.",
  assets_config: "Config. de ativos",
  code: "Código",
  deposits: "Depósitos",
  min_withdrawal: "Saque mín.",
  withdrawal_fee: "Taxa de saque",
  successfully_created_deposit_address: "Você criou o novo endereço de depósito com sucesso",
  label: "Rótulo",
  address: "Endereço",
  creating_address_successful: "Endereço criado com sucesso",
  deposit_info: "Depósitos bancários",
  deposit_info_details: "Informações de depósito bancário",
  deposit_addresses_title: "Depósitos em cripto",
  deposit_addresses: "Endereços de depósito",
  available_deposit_addresses: "Endereços de depósito disponíveis para {{transactionNetwork}}",
  new_deposit_address: "Novo endereço de depósito",
  initial: "Inicial",
  pending: "Pendente",
  settled: "Liquidado",
  success: "Sucesso",
  failure: "Falha",
  partial: "Parcial",
  amlreview: "Em análise",
  filter_deposits: "Filtro de depósitos",
  filter_invoices: "Filtro de links de pagamento",
  invoice_payments: "Pagamentos",
  amount_min: "Valor mín.",
  amount_max: "Valor máx.",
  min_eur_value: "Valor mín. em EUR",
  max_eur_value: "Valor máx. em EUR",
  currency: "Moeda",
  status: "Status",
  deposit_id: "ID do depósito",
  transaction: "Transação",
  transaction_network: "Rede da transação",
  transaction_fee: "Taxa de transação paga pelo pagador",
  next: "Avançar",
  back: "Voltar",
  invoice_submitted_for_review: "Link de pagamento enviado para análise do MLRO",
  invoice_payer_address: "Endereço da carteira cripto do pagador",
  invoice_payer_address_required: "O endereço do pagador é obrigatório.",
  invoice_address_unsupported: "Endereço não reconhecido ou não compatível",
  invoice_payer_unknown: "Não sei o endereço cripto do pagador",
  invoice_supporting_documents: "Documentos de apoio",
  invoice_compliance_documents: "Documentos de compliance",
  invoice_additional_documents: "Documentos adicionais (opcional)",
  invoice_additional_comments: "Comentários adicionais (opcional)",
  invoice_additional_comments_placeholder: "Qualquer contexto extra para o analista de compliance (opcional)",
  invoice_document_not_applicable: "Não se aplica",
  invoice_compliance_documents_required: "Todos os documentos de compliance devem ser enviados ou marcados como não aplicáveis",
  invoice_upload_documents: "Enviar arquivos",
  invoice_document_too_large: "{{filename}} tem {{size}} — cada arquivo deve ter no máximo {{limit}}",
  invoice_documents_too_many: "Você pode anexar no máximo 10 arquivos",
  invoice_document_uploading: "Enviando…",
  invoice_documents_uploading: "Aguarde o envio dos documentos terminar",
  invoice_copy_from_previous: "Copiar de anterior",
  invoice_copy_title: "Copiar de um link de pagamento anterior",
  invoice_copy_search_placeholder: "Buscar por nome",
  invoice_copy_note: "Escolha um link de pagamento para preencher esta etapa com os dados dele — o endereço do pagador, os documentos de compliance e os comentários enviados. Os documentos não são enviados novamente.",
  invoice_copy_empty: "Você ainda não tem links de pagamento enviados para copiar",
  invoice_copy_no_matches: "Nenhum link de pagamento corresponde a essa busca",
  invoice_copy_in_progress: "Copiando…",
  invoice_copy_documents_refused: "Estes documentos foram enviados por outro usuário e precisam ser anexados novamente: {{filenames}}",
  invoice_discard_title: "Descartar este link de pagamento?",
  invoice_discard_message: "Tudo o que você inseriu aqui, incluindo os documentos enviados, será perdido.",
  creating: "Criando…",
  discard: "Descartar",
  keep_editing: "Continuar editando",
  form_has_errors: "Corrija os campos destacados",
  description: "Descrição",
  details: "Detalhes",
  deposit_details: "Detalhes do depósito",
  asset: "Ativo",
  create_deposit_address: "Criar novo endereço de depósito",
  edit_deposit_address: "Editar endereço de depósito",
  generate_deposit_address: "Gerar novo endereço de depósito",
  payment_method: "Método de pagamento",
  label_name: "Nome do rótulo",
  label_id: "ID do rótulo",
  copy_to_clipboard: "Copiar para a área de transferência",
  copied: "Copiado",
  client_name: "Nome do cliente",
  client_id: "ID do cliente",
  beneficiary_name: "Nome do beneficiário",
  beneficiary_address: "Endereço do beneficiário",
  bank_name: "Nome do banco",
  bank_address: "Endereço do banco",
  include_reference_code: "Inclua o código de referência a seguir ao nos enviar fundos",
  invalid_address: "Endereço {{transactionNetwork}} inválido",
  invalid_address_eip55: "Endereço {{transactionNetwork}} inválido (falha na validação EIP-55)",
  select_transaction_network: "Selecione a rede da transação",
  euro_value: "Valor em EURO",
  euro_deposits: "Depósitos em euro",
  gbp_deposits: "Depósitos em GBP",
  send_euro_to_bank: "Envie todos os depósitos em euro para a conta bancária a seguir",
  send_gbp_to_bank: "Envie todos os depósitos em GBP para a conta bancária a seguir",
  error: "Erro",
  error_requesting_data: "Ocorreu um erro ao solicitar os dados",
  payout: "Repasse",
  trade: "Operação",
  deposit: "Depósito",
  withdraw: "Sacar",
  filter_ledger: "Filtro do livro-razão",
  filter_users_list: "Filtro da lista de usuários",
  filter_mlro: "Filtro do relatório MLRO",
  category: "Categoria",
  operation_id: "ID da operação",
  amount: "Valor",
  fees: "Taxas",
  fee: "Taxa",
  balance_after: "Saldo após",
  logged_out: "Sessão encerrada",
  you_logged_out: "Você saiu da sua conta",
  no_clients_exists: "Não há clientes nesta conta",
  clients_load_failed: "Não foi possível carregar seus clientes",
  sign_in_failed: "Não foi possível concluir seu login",
  try_again: "Tentar novamente",
  notifications: "Notificações",
  contact_to_create_clients: "Entre em contato conosco para criar clientes na sua conta",
  sold: "vendeu",
  save: "Salvar",
  settings: "Configurações",
  updated_user_settings: "As configurações do usuário foram salvas com sucesso",
  users_list: "Lista de usuários",
  user_id: "ID do usuário",
  is_admin: "Admin",
  bought: "comprou",
  trade_successful: "Operação realizada com sucesso",
  you_successfully: "Você realizou com sucesso",
  for: "por",
  no_pair_configured: "Nenhum par de ativos configurado",
  contact_to_add_asset_pair: "Fale com o suporte para adicionar um novo par de ativos",
  withdrawal_successful: "Saque realizado com sucesso",
  successfully_posted_withdrawal: "Você solicitou com sucesso o saque de",
  successfully_created_withdrawal_address: "Você criou o novo endereço de saque com sucesso",
  successfully_updated_withdrawal_address: "Você atualizou o endereço de saque com sucesso",
  updating_address_successful: "Endereço atualizado com sucesso",
  successfully_deleted_withdrawal_address: "Você excluiu o endereço de saque com sucesso",
  deleting_address_successful: "Endereço excluído com sucesso",
  withdrawals: "Saques",
  withdrawal_addresses: "Endereços de saque",
  crypto_addresses: "Endereços cripto",
  bank_addresses: "Contas bancárias",
  withdrawal_method: "Método de saque",
  new_withdrawal_address: "Adicionar novo endereço de saque",
  new_bank_address: "Adicionar nova conta bancária",
  approve_to_make_withdrawal: "Você precisa adicionar um endereço de saque para esta moeda antes de poder fazer saques",
  make_withdrawal: "Fazer saque",
  min_deposit: "Depósito mínimo",
  min_deposit_amounts: "Valores mínimos de depósito",
  filter_withdrawals: "Filtro de saques",
  filter_payouts: "Filtro de repasses",
  withdrawal_id: "ID do saque",
  withdrawals_history: "Histórico de saques",
  payouts_history: "Histórico de repasses",
  reference_id: "ID de referência",
  payout_amount: "Valor do repasse",
  source_amount: "Valor de origem",
  provide_valid_address: "Informe um endereço válido",
  provide_valid_iban: "Informe um IBAN válido",
  provide_valid_bic: "Informe um código BIC válido",
  unique_label_coin: "Crie um nome de rótulo único para este endereço de moeda",
  unique_label_bank: "Crie um nome de rótulo único para esta conta bancária",
  iban_number: "IBAN/Número da conta",
  bic_code: "Código BIC",
  name_bank: "Nome do banco",
  address_bank: "Endereço do banco",
  iban_description: "O IBAN/número da conta bancária",
  bic_description: "O código BIC/SWIFT do banco",
  bank_description: "O nome do banco, não da agência",
  bank_address_description: "O endereço do banco, não da agência",
  name_beneficiary: "Nome do beneficiário",
  beneficiary_name_description: "O nome da empresa titular da conta bancária para a qual você quer enviar fundos. Não pode ser uma pessoa física; deve ser o nome de uma empresa",
  beneficiary_address_description: "O endereço registrado da empresa titular desta conta bancária",
  address_beneficiary: "Endereço do beneficiário",
  create_withdrawal_address: "Criar novo endereço de saque",
  create_bank_withdrawal_address: "Adicionar nova conta bancária",
  delete_address_description: "Você está prestes a excluir o endereço de saque",
  deleting_withdrawal_address: "Excluindo endereço de saque",
  delete_withdrawal_address: "Excluir endereço de saque",
  address_details: "Detalhes do endereço",
  update_withdrawal_address: "Atualizar endereço de saque",
  update_address: "Atualizar endereço",
  pair: "Par",
  tenant_name: "Tenant",
  delete_pair_question: "Deseja excluir o par",
  deleting_trading_pair: "Excluindo par de negociação",
  yes_delete_pair: "Sim, excluir par",
  deleting_successful: "Exclusão concluída",
  successfully_deleted_pair: "Você excluiu o par com sucesso",
  estimated_values_assets: "Valores estimados do ativo",
  field_required: "Campo obrigatório",
  want_to_create_trade: "Deseja criar uma nova operação de {{type}} de {{amountSubmit}} {{asset}}?",
  new_trading_offer_exchange: "{{operation}} {{primaryAmount}} {{primaryAsset}} por {{secondaryAmount}} {{secondaryAsset}}",
  new_payout_offer_exchange: "Repasse: {{payoutAmount}} {{payoutAsset}}",
  new_trading_offer_rate: "Taxa de câmbio desta oferta: {{rate}}",
  new_trading_offer_fees: "Taxas: {{feeAmount}} {{feeAsset}}",
  new_trading_offer_no_fees: "A taxa de câmbio oferecida inclui todas as taxas de transação",
  new_payout_offer_fees: "Taxas: {{totalFeesInSourceAsset}} {{sourceAsset}}",
  new_payout_offer_total_cost: "Custo total: {{totalCostInSourceAsset}} {{sourceAsset}}",
  posting_new_trade: "Enviando nova operação",
  exchange_rate: "Taxa de câmbio",
  trading_offer: "Oferta de operação",
  payout_offer: "Oferta de repasse",
  payout_details: "Detalhes do repasse",
  requesting_new_trade: "Solicitando oferta de operação",
  requesting_new_payout: "Solicitando oferta de repasse",
  yes_create_trade: "Sim, criar operação",
  number_at_min: "O número deve ser no mínimo",
  amount_buy_sell: "Valor a comprar/vender",
  amount_spend_receive: "Valor a gastar/receber",
  spend: "Gastar",
  receive: "Receber",
  buy_price: "Preço de compra",
  sell_price: "Preço de venda",
  balances: "Saldos",
  no_balances: "Sem saldos",
  copyright: "Copyright",
  all_rights_reserved: "Todos os direitos reservados",
  selected_client: "Cliente selecionado",
  logout: "Sair",
  dashboard: "Painel",
  select_client: "Selecionar cliente",
  trading_panel: "Painel de negociação",
  ledger: "Livro-razão",
  mlro: "Relatório MLRO",
  email_invalid: "E-mail inválido",
  send_email: "Enviar e-mail",
  email: "E-mail",
  removing_2fa_successful: "Autenticação de dois fatores removida com sucesso",
  value_invalid: "Valor inválido",
  id_invalid: "ID inválido",
  operation_id_invalid: "ID da operação inválido",
  trade_id_invalid: "ID da operação inválido",
  withdrawal_id_invalid: "ID do saque inválido",
  address_invalid: "Endereço inválido",
  date_invalid: "Data inválida",
  insufficient_funds: "Saldo insuficiente. Você tem {{amountToSpend}} {{spendCurrency}} para gastar",
  type_error: "O valor deve ser um(a) {{type}}",
  length_error: "O valor deve ter exatamente {{length}} caracteres",
  min_error: "O valor deve ter pelo menos {{min}} caracteres",
  max_error: "O valor não pode ter mais de {{max}} caracteres",
  min_number_error: "O número deve ser no mínimo {{min}}",
  max_number_error: "O número deve ser no máximo {{max}}",
  less_number_error: "O número deve ser menor que {{max}}",
  should_be_more: "O valor deve ser maior que {{min}}",
  export: "Exportar",
  panel: "Painel",
  change_language: "Alterar idioma",
  approved: "Aprovado",
  field_digits_message: "O campo deve ter no máximo {{count}} casas decimais",
  bank_withdrawal: "Saque bancário",
  qr_code: "Código QR",
  sign_up: "Cadastrar-se",
  client_info: "Informações do cliente",
  current_fee: "Taxa atual",
  client_fees: "Taxas do cliente",
  current_trade_volume: "Volume de negociação atual",
  tx_fee_schedule: "Tabela de taxas",
  volume_needed_for_next_tier: "Volume necessário para o próximo nível",
  client_api_keys: "Chaves de API do cliente",
  workflows: "Fluxos de trabalho",
  external_id: "ID externo",
  no_options: "Sem opções",
  nav_trading: "Negociação",
  nav_balances: "Saldos",
  nav_deposits: "Depósitos",
  nav_deposit_addresses: "Endereços de depósito",
  nav_withdrawals: "Saques",
  nav_payouts: "Repasses",
  nav_payment_links: "Link de pagamento",
  nav_workflows: "Fluxos de trabalho",
  nav_ledger: "Livro-razão",
  nav_client: "Informações do cliente",
  theme: "Tema",
  dark_mode: "Modo escuro",
  loading: "Carregando",
  view_as_banner: "Você está vendo o painel como {{email}}. Somente leitura: nada pode ser alterado.",
  act_as_banner: "Você está agindo como {{email}}. As alterações são registradas como feitas por você em nome dessa pessoa.",
  view_as_return: "Voltar à minha conta",
  view_as_failed: "Não foi possível ver o painel como esse usuário: {{message}}",
  add_new_workflow: "Adicionar novo fluxo de trabalho",
  workflow: "Fluxo de trabalho",
  enabled: "Ativado",
  add_workflow: "Adicionar fluxo de trabalho",
  workflow_created: "Novo fluxo de trabalho do cliente criado",
  workflow_deleted: "Fluxo de trabalho excluído",
  workflow_delete_confirm: "Este fluxo de trabalho será excluído.",
  no_workflows: "Nenhum fluxo de trabalho.",
  are_you_sure: "Tem certeza?",
  asset_to_buy: "Ativo a comprar",
  workflow_when: "Quando",
  workflow_is_deposited: "for depositado,",
  workflow_convert_to: "converter para",
  workflow_using_market_order: "usando ordem a mercado.",
  deposit_asset: "Ativo do depósito",
  password: "Senha",
  sign_up_to: "Cadastre-se na {{brand}}",
  registration_success_message: "Acesse sua caixa de entrada para confirmar seu e-mail",
  registration_error_title: "Ocorreu um erro!",
  please_try_again: "Tente novamente",
  invitation_not_valid: "Este link de convite não é válido",
  invitation_not_valid_message: "Peça ao seu administrador para enviar um novo convite.",
  invitation_revoked: "Este convite foi revogado",
  invitation_revoked_message: "Ele foi cancelado por um administrador. Peça um novo link de convite.",
  invitation_expired: "Este convite expirou",
  invitation_expired_message: "Os links de convite são válidos por tempo limitado. Peça um novo ao seu administrador.",
  invitation_used: "Este convite já foi usado",
  invitation_used_message: "Uma conta já foi criada com este link. Tente fazer login.",
  invitation_check_failed: "Não foi possível verificar seu convite",
  invitation_check_failed_message: "Você pode continuar — ele será verificado quando você se cadastrar.",
  already_have_account: "Já tem uma conta?",
  login: "Entrar",
  password_should_contain: "A senha deve conter:",
  password_too_weak: "Muito fraca",
  pwd_number: "Número",
  pwd_lowercase: "Letra minúscula",
  pwd_uppercase: "Letra maiúscula",
  pwd_special: "Caractere especial",
  pwd_min_length: "Pelo menos 8 caracteres",
  pwd_no_email: "Nada do seu endereço de e-mail",
  pwd_contains_email: "A senha não pode conter seu endereço de e-mail nem a parte antes do @",
  password_too_weak_error: "A senha é muito fraca. Use uma mais longa, com mais tipos de caracteres",
  pwd_too_common: "A senha é muito comum. Escolha uma mais difícil de adivinhar",
  clear_filters: "Limpar filtros",
  all: "Todos",
  confirm: "Confirmar",
  create: "Criar",
  action: "Ação",
  download_pdf: "Baixar PDF",
  no_deposits: "Nenhum depósito.",
  no_deposit_addresses: "Nenhum endereço de depósito.",
  no_deposit_methods: "Nenhum método de depósito.",
  no_ledger_entries: "Nenhum lançamento no livro-razão.",
  all_operations_for_id: "Todas as operações do ID: {{id}}",
  current_balances: "Saldos atuais",
  account_value: "Valor da conta",
  fiat_balances: "Saldos em moeda fiduciária",
  coin_balances: "Saldos em criptomoedas",
  client_legal_name: "Razão social",
  select_all: "Selecionar tudo",
  api_key_permissions: "Selecione as permissões da chave de API:",
  add_ip_address: "Adicionar endereço IP",
  ip_address: "Endereço IP",
  allowed_ip_addresses: "Endereços IP permitidos",
  no_ip_addresses_yet: "Nenhum endereço IP ainda.",
  ip_address_added: "Novo endereço IP adicionado com sucesso",
  generate_callback_secret_question: "Deseja gerar um novo segredo de callback?",
  error_occured_title: "Ocorreu um erro",
  create_payout: "Criar repasse",
  prepare_payout_offer: "Preparar uma oferta de repasse",
  payout_method: "Método de repasse",
  source_asset: "Ativo de origem",
  select_asset: "Selecionar ativo",
  charge_me_in: "Cobrar em...",
  i_know_amount: "Sei o valor em {{asset}}",
  callback_url_optional: "URL de callback (opcional)",
  resend_callback: "Reenviar callback",
  callback_resent: "Callback reenviado com sucesso",
  payout_added: "Novo repasse adicionado com sucesso",
  no_payouts: "Nenhum repasse.",
  remaining: "Restante",
  seconds: "segundos",
  include_tx_fee: "Incluir taxa de transação na taxa de câmbio",
  no_trades: "Nenhuma operação.",
  no_withdrawals: "Nenhum saque.",
  no_withdrawal_addresses: "Nenhum endereço de saque.",
  no_bank_accounts: "Nenhuma conta bancária.",
  no_api_keys: "Nenhuma chave de API.",
  payment_link_fees: "Taxas do link de pagamento",
  payout_step_send_asset: "Selecione o ativo a enviar",
  payout_step_charge_asset: "Selecione o ativo em que deseja ser cobrado",
  payout_step_amount: "Informe o valor",
  payout_step_address: "Informe o endereço e dados opcionais",
  description_optional: "Descrição (opcional)",
  external_id_optional: "ID externo (opcional)",
  paid: "Pago",
  amount_due: "Valor devido (incl. taxa de transação)",
  outstanding: "Em aberto",
  outstanding_note: "O pagador enviou menos que o valor devido.",
  partly_paid: "Parcialmente pago",
  unpaid: "Não pago",
  expired: "Expirado",
  rejected: "Rejeitado",
  in_review: "Em análise",
  payment_in_review: "Pagamento em análise",
  draft_rejected: "Rascunho rejeitado",
  created_at: "Criado em",
  expires_at: "Expira em",
  url: "URL",
  locked_payment: "Pagamento bloqueado",
  declared_payer_addresses: "Endereços de pagador declarados",
  additional_comments: "Comentários adicionais",
  no_payments_yet: "Nenhum pagamento ainda.",
  none_declared: "Nenhum declarado",
  none_attached: "Nenhum anexado",
  customer_support: "Suporte ao cliente",
  view_the_payment_link: "Ver o link de pagamento",
  create_payment_link: "Criar link de pagamento",
  edit_payment_link: "Editar link de pagamento",
  delete_payment_link: "Excluir link de pagamento",
  payment_link_delete_confirm: "Tem certeza de que deseja excluir este link de pagamento?",
  draft: "Rascunho",
  confirmed: "Confirmado",
  flagged_by_aml: "Sinalizado pelo AML",
  unknown_payer: "Pagador desconhecido",
  draft_approved: "Rascunho aprovado.",
  no_payment_links: "Nenhum link de pagamento.",
  payment_link_number: "Link de pagamento #{{id}}",
  pending_payment_link_number: "Link de pagamento pendente #{{id}}",
  contact_support_for_assistance: "Entre em contato com {{email}} para obter ajuda.",
  payment_link_added: "Novo link de pagamento adicionado com sucesso",
  payment_link_delete_body: "O link de pagamento deixará de aceitar pagamentos.",
  document_passport: "Passaporte",
  document_purchase_agreement: "Contrato de compra assinado",
  document_proof_of_address: "Comprovante de endereço",
  document_source_of_funds: "Origem dos fundos",
  impersonation_warning: "Você está logado como {{client}}. Qualquer ação realizada afetará a conta deste cliente.",
  terms_greeting: "Prezado cliente,",
  terms_intro_updated: "Atualizamos nossos Termos e Condições para refletir melhor nossos serviços e garantir mais clareza para você.",
  terms_intro_review: "Leia-os abaixo. Para continuar usando nossos serviços, confirme que você aceita os Termos e Condições atualizados:",
  terms_questions: "Se tiver dúvidas, fale conosco em {{email}}",
};
